module.exports = __webpack_public_path__ + "img/inventory_transfer.c00227c6.svg";